
/**
 * Billing frequency
 */
export type GetPlanById200BillingCycle = typeof GetPlanById200BillingCycle[keyof typeof GetPlanById200BillingCycle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPlanById200BillingCycle = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  ONE_TIME: 'ONE_TIME',
} as const;
